import {createSelector} from "reselect";
import {getAccounts, getArticleOptionsData, getContracts} from "./SimpleSelectors";
import {delve} from "../util/util";
import {_account, _contract} from "./GetParam";

export const getCurrentAccountByContract = createSelector(
    [getContracts],
    (contracts) => {
        return delve(contracts, _contract + ".sourceUid") || _account;
    }
)

export const getAccountProjectSpace = createSelector(
    [getAccounts, getCurrentAccountByContract, getArticleOptionsData],
    (accounts, currentAccount, articleOptionsData) => {
        if (!accounts || !currentAccount || !articleOptionsData) {
            return 0;
        }
        if (!accounts[currentAccount] || !accounts[currentAccount].article) {
            return 0;
        }
        return Number((delve(articleOptionsData, accounts[currentAccount].article.articleNumber + ".projectSpace") || 0)) / 1024 / 1024;
    }
)

export const getAccountStorageUsage = createSelector(
    [getAccounts, getCurrentAccountByContract],
    (accounts, currentAccount) => {
        if (!accounts || !currentAccount) {
            return 0;
        }
        return Number((delve(accounts, currentAccount + ".stats.summary") || 0)) / 1024 / 1024;
    }
)
export const getAccountBackupRange = createSelector(
    [getAccounts, getCurrentAccountByContract],
    (accounts, currentAccount) => {
        if (!accounts || !currentAccount) {
            return 0;
        }
        return Number((delve(accounts, currentAccount + ".backupRange") || 7));
    }
)

export const getAccountStorageLimit = createSelector(
    [getAccounts, getCurrentAccountByContract],
    (accounts, currentAccount) => {
        if (!accounts || !currentAccount) {
            return 0;
        }
        return Number((delve(accounts, currentAccount + ".stats.limit") || 0) / 1024 / 1024);
    }
)

export const getAccountExtraStorage = createSelector(
    [getAccountStorageLimit, getAccountProjectSpace],
    (storageLimit, projectSpace) => {
        return Number(storageLimit - projectSpace);
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/Accounts.js
 **/